import React from 'react';
import styles from './route.module.scss';

const RouteSection = ({ title, data, columns }) => {
  if (!data || data.length === 0) return null;

  return (
    <div className={styles.route_section}>
      <div className={styles.section_title}>{title}</div>
      <table className={styles.route_table}>
        <thead>
          <tr>
            {columns.map(col => (
              <th key={col.key}>{col.title}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={index}>
              {columns.map(col => (
                <td key={col.key}>{row[col.dataIndex]}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const RoutingPage = ({ routeInfo }) => {
  // 기본 라우팅, 네트워크 라우팅, IPv6 라우팅용 컬럼
  const standardColumns = [
    { title: 'Network', dataIndex: 'network', key: 'network' },
    { title: 'Gateway', dataIndex: 'gateway', key: 'gateway' },
    { title: 'Interface', dataIndex: 'interface', key: 'interface' },
    { title: 'Flags', dataIndex: 'flags', key: 'flags' },
  ];

  // Local, Broadcast 라우팅용 컬럼
  const typeBasedColumns = [
    { title: 'Type', dataIndex: 'type', key: 'type' },
    { title: 'Network', dataIndex: 'network', key: 'network' },
    { title: 'Interface', dataIndex: 'interface', key: 'interface' },
    { title: 'Flags', dataIndex: 'flags', key: 'flags' },
  ];

  // Unreachable 라우팅용 컬럼
  const unreachableColumns = [
    { title: 'Type', dataIndex: 'type', key: 'type' },
    { title: 'Network', dataIndex: 'network', key: 'network' },
    { title: 'Flags', dataIndex: 'flags', key: 'flags' },
  ];

  // routeInfo 문자열 파싱
  const parseRouteInfo = (routeInfo) => {
    if (!routeInfo || routeInfo === 'N/A') return null;

    const sections = {
      'Default Routing': [],
      'Network Routing': [],
      'Local Routing': [],
      'Broadcast Routing': [],
      'IPv6 Routing': [],
      'Unreachable Routes': []
    };

    let currentSection = '';
    const lines = routeInfo.split('\n');

    lines.forEach(line => {
      if (line.startsWith('===')) {
        currentSection = line.replace(/===/g, '').trim();
        return;
      }

      if (!line.trim() || line.includes('Network\tGateway') || line.includes('Type\tNetwork')) {
        return;
      }

      const parts = line.split('\t');
      if (parts.length < 3) return;

      const entry = {};
      
      if (currentSection === 'Default Routing' || currentSection === 'Network Routing' || currentSection === 'IPv6 Routing') {
        [entry.network, entry.gateway, entry.interface, entry.flags] = parts;
      } else if (currentSection === 'Local Routing' || currentSection === 'Broadcast Routing') {
        [entry.type, entry.network, entry.interface, entry.flags] = parts;
      } else if (currentSection === 'Unreachable Routes') {
        [entry.type, entry.network, entry.flags] = parts;
      }

      if (sections[currentSection]) {
        sections[currentSection].push({
          ...entry,
          key: Math.random().toString(36).substr(2, 9)
        });
      }
    });

    return sections;
  };

  const parsedData = parseRouteInfo(routeInfo);

  if (!parsedData) {
    return null;
  }

  return (
    <div className={styles.route_container}>
      <h2>Routing Information</h2>
      <div className={styles.route_content}>
        <RouteSection 
          title="Default Routing"
          columns={standardColumns}
          data={parsedData['Default Routing']}
        />
        <RouteSection 
          title="Network Routing"
          columns={standardColumns}
          data={parsedData['Network Routing']}
        />
        <RouteSection 
          title="Local Routing"
          columns={typeBasedColumns}
          data={parsedData['Local Routing']}
        />
        <RouteSection 
          title="Broadcast Routing"
          columns={typeBasedColumns}
          data={parsedData['Broadcast Routing']}
        />
        <RouteSection 
          title="IPv6 Routing"
          columns={standardColumns}
          data={parsedData['IPv6 Routing']}
        />
        <RouteSection 
          title="Unreachable Routes"
          columns={unreachableColumns}
          data={parsedData['Unreachable Routes']}
        />
      </div>
    </div>
  );
};

export default RoutingPage;
